/**
 * @generated SignedSource<<06985bd688376a421b0e31eb22927273>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsResourcesSubNav_viewer$data = {
  readonly email: string | null;
  readonly " $fragmentType": "SettingsResourcesSubNav_viewer";
};
export type SettingsResourcesSubNav_viewer$key = {
  readonly " $data"?: SettingsResourcesSubNav_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SettingsResourcesSubNav_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SettingsResourcesSubNav_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c8c3eef97856712fa711824bb3cbb742";

export default node;
